import React, { useEffect, useState } from 'react';
import axios from '../helpers/axiosConfig';
axios.defaults.withCredentials = true;

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [erreur, setErreur] = useState(null);

  useEffect(() => {
    axios
      .get('/personnel/dashboard/statsparserviceinterne/1/x')
      .then((response) => {
        setStats(response.data);
      })
      .catch((error) => {
        setErreur('There was an error fetching the stats!', error);
      });
  }, []);

  if (!stats) {
    return <div className="container mt-5 pt-5">Loading...</div>;
  }

  return (
    <div className="container mt-5 pt-5">
      <h2 className="text-center mb-4 alert alert-success ">Statistique provisoir des personnels civils</h2>
      {erreur && <div> {erreur} </div>}
      <div className="alert alert-primary text-center p-5  ">
        <h4>Total des Personnels CIVIL</h4>
        <div style={{ fontSize: 80, fontFamily: 'impact' }}>{stats.totalCivil}</div>
      </div>

      {/* Totaux par grade */}
      <div className="row">
        <div className="col text-center ">
          <div className="alert alert-warning">
            <h5>FONCTIONNAIRE</h5>
            <div style={{ fontSize: 80, fontFamily: 'impact' }}>{stats.grades.FONCTIONNAIRE}</div>
          </div>
        </div>
        <div className="col text-center">
          <div className="alert alert-danger">
            <h5>EFA</h5>
            <div style={{ fontSize: 80, fontFamily: 'impact' }}>{stats.grades.EFA}</div>
          </div>
        </div>
        <div className="col text-success">
          <div className="alert alert-primary text-center ">
            <h5>ELD</h5>
            <div style={{ fontSize: 80, fontFamily: 'impact' }}>{stats.grades.ELD}</div>
          </div>
        </div>
      </div>

      {/* Tableau des personnels par Etsouservice */}
      <table className="table table-bordered">
        <thead className="thead-dark">
          <tr>
            <th>Etsouservice</th>
            <th>FONCTIONNAIRE</th>
            <th>EFA</th>
            <th>ELD</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(stats.etsouservices).map((etsouserviceName) => (
            <tr key={etsouserviceName}>
              <td>{etsouserviceName}</td>
              <td>{stats.etsouservices[etsouserviceName].FONCTIONNAIRE}</td>
              <td>{stats.etsouservices[etsouserviceName].EFA}</td>
              <td>{stats.etsouservices[etsouserviceName].ELD}</td>
              <td className="bg-primary">{stats.etsouservices[etsouserviceName].TOTAL}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-primary">
            <th>Total Général</th>
            <th>{stats.grades.FONCTIONNAIRE}</th>
            <th>{stats.grades.EFA}</th>
            <th>{stats.grades.ELD}</th>
            <th className="bg-danger">{stats.totalCivil}</th>
          </tr>
        </tfoot>
      </table>

      {/* Total des personnels par sexe */}
      <div className="row">
        <div className="col">
          <h4>FONCTIONNAIRE</h4>
          <p>HOMME: {stats.sexes.M.FONCTIONNAIRE}</p>
          <p>FEMME: {stats.sexes.F.FONCTIONNAIRE}</p>
        </div>
        <div className="col">
          <h4>EFA</h4>
          <p>HOMME: {stats.sexes.M.EFA}</p>
          <p>FEMME: {stats.sexes.F.EFA}</p>
        </div>
        <div className="col">
          <h4>ELD</h4>
          <p>HOMME: {stats.sexes.M.ELD}</p>
          <p>FEMME: {stats.sexes.F.ELD}</p>
        </div>
      </div>
      {/* Total par statut marital */}
      <div className="row">
        <div className="col">
          <h4>Célibataire</h4>
          <p>HOMME: {stats.maritalStatus.CELIBATAIRE.M}</p>
          <p>FEMME: {stats.maritalStatus.CELIBATAIRE.F}</p>
        </div>
        <div className="col">
          <h4>Divorcé</h4>
          <p>HOMME: {stats.maritalStatus.DIVORCE.M}</p>
          <p>FEMME: {stats.maritalStatus.DIVORCE.F}</p>
        </div>
        <div className="col">
          <h4>Veuf(ve)</h4>
          <p>HOMME: {stats.maritalStatus.VEUF.M}</p>
          <p>FEMME: {stats.maritalStatus.VEUF.F}</p>
        </div>
        <div className="col">
          <h4>Marié</h4>
          <p>HOMME: {stats.maritalStatus.MARIE.M}</p>
          <p>FEMME: {stats.maritalStatus.MARIE.F}</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
